// extracted by mini-css-extract-plugin
export default {"FormInput":"FormInput_FormInput__vowb8","error":"FormInput_error__7pogf"};